import * as theme from "./AiErrorLLMRejected.css";

interface AiErrorLLMRejectedProps {
    message: string;
    variant?: "centered" | "fullWidth";
}

export function AiErrorLLMRejected({
    message,
    variant = "centered",
}: AiErrorLLMRejectedProps) {
    return (
        <div className={theme.rejectedState[variant]}>
            <span className={theme.rejectedText}>{message}</span>
        </div>
    );
}
